export default __webpack_public_path__ + "static/media/information.33fd0524.svg";